import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { CollectionOwner } from "../../CollectionOwner/CollectionOwner";
import { CollectionOwnerFragment } from "../../CollectionOwner/CollectionOwner.fragment";
export const CollectionOwnerChipFragment = graphql(`
    fragment CollectionOwnerChip on Collection {
      ...CollectionOwner
    }
  `, [CollectionOwnerFragment]);
export function CollectionOwnerChip(t0) {
  const $ = _c(6);
  const {
    collection: collectionKey,
    variant: t1,
    chipVariant
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  let t2;
  if ($[0] !== collectionKey) {
    t2 = readFragment(CollectionOwnerChipFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const collection = t2;
  let t3;
  if ($[2] !== chipVariant || $[3] !== collection || $[4] !== variant) {
    t3 = <CollectionOwner chipVariant={chipVariant} collection={collection} variant={variant} />;
    $[2] = chipVariant;
    $[3] = collection;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}